export default "__VITE_ASSET__Q79dV7Tl__"